module.exports = __webpack_public_path__ + "286675cda40f651bb0da44f105cd7d7d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-32.png
// module id = 3295
// module chunks = 0